export const styles: any = {
  completedBox: {
    fontFamily: 'lato',
    color: '#4CAF51',
    height: '2em',
    width: 'auto',
    backgroundColor: '#EDF7ED',
    textTransform: 'capitalize',
    fontSize: '0.75em',
  },
  pendingBox: {
    fontFamily: 'lato',
    color: '#FF5263',
    height: '2em',
    width: 'auto',
    backgroundColor: '#FFEDEF',
    textTransform: 'capitalize',
    fontSize: '0.75em',
  },
  radioButton: {
    backgroundColor: '#FAFAFA',
    borderRadius: '0.3em',
    padding: ' 0.3em 6em 0.3em 0.3em',
    marginBottom: '0.5em',
    color: '#575757',
  },
  evaluatorButton: {
    border: '1px solid #0000001F',
    padding: '1em',
    marginTop: '1em',
    borderRadius: '7px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'space-between',
    '&:hover': {
      backgroundColor: 'red',
    },
  },
};
